import React from "react";
import "./Login.css";

const TILE_ROWS = [
  { direction: "left", offset: 0 },
  { direction: "right", offset: 5 },
  { direction: "left", offset: 10 },
  { direction: "right", offset: 15 },
];

const TILE_COUNT = 20;

function AssetBackdrop() {
  return (
    <div className="login-asset-field" aria-hidden="true">
      {TILE_ROWS.map((row, rowIndex) => (
        <div
          className={`login-asset-row ${
            row.direction === "right" ? "reverse" : ""
          }`}
          key={rowIndex}
        >
          <div className="login-asset-track">
            {[0, 1].map((trackIndex) =>
              Array.from({ length: TILE_COUNT }).map((_, tileIndex) => {
                const variant = ((tileIndex + row.offset) % 8) + 1;
                return (
                  <span
                    className={`login-asset-tile tile-${variant}`}
                    key={`${trackIndex}-${tileIndex}`}
                  />
                );
              })
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AssetBackdrop;
